module.exports = __webpack_public_path__ + "static/mapa-a670ee512e08d701de2fc75df25bcdb6.webp";